import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from "@angular/router";
import { lastValueFrom } from "rxjs";
import { WarehouseBackend } from "src/app/backend/api/warehouse.backend";
import { appState } from "src/app/core/state";

@Injectable()
export class ProvideStoragesGuard implements CanActivate {
  private readonly warehouseBackend = inject(WarehouseBackend);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      appState.storages = await lastValueFrom(
        this.warehouseBackend.listStoragesLightAll()
      );
    } catch (ex) {
      reportError(ex);
    }

    return true;
  }
}
